<template>
  <div class="nav-box">
    <div class="nav-list">
      <div class="item" :class="{active:index===navIndex}" v-for="(item,index) in navList" :key="item.id" @click="changeNav(index)">{{ item.name }}</div>
    </div>
    <el-button type="primary" plain size="mini" @click="exportEv" v-if="isExport">导出</el-button>
  </div>
</template>

<script>
  export default{
    props:{
      navList:{
        type:Array,
        default:[]
      },
      isExport:{
        type:Boolean,
        default:false
      }
    },
    data() {
      return {
        navIndex: 0
      }
    },
    methods: {
      // 选择导航
      changeNav(index) {
        if(index===this.navIndex) return;
        this.navIndex = index;
        this.$emit('changeNav', index);
      },
      // 导出
      exportEv() {
        this.$emit('exportEv');
      }
    }
  }
</script>

<style scoped lang="scss">
  .nav-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .nav-list {
      display: flex;
      align-items: center;
      max-width: calc(100% - 150px);
      .item {
        margin-right: 30px;
        font-size: 14px;
        color: #101010;
        cursor: pointer;
        &.active {
          color: #1596CD;
          font-weight: bold;
        }
      }
    }
  }
</style>
